var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHappyGuy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 378.36 541.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f4cfb4;}.cls-2{fill:#f2f2f2;}.cls-3{fill:#e8c7b1;}.cls-4{fill:#5b3324;}.cls-5{fill:#512c21;}.cls-6{fill:#e5e4e3;}.cls-7{fill:#e55c45;}.cls-8{fill:#262626;}.cls-9{fill:#261d19;}.cls-10{fill:#fff;}.cls-11{fill:#562f22;}.cls-12{fill:#e5c3ac;}.cls-13{fill:#663629;}.cls-14{fill:#663a27;}.cls-15{fill:#7c4633;}.cls-16{fill:#d8544a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Object"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "103.7 247.06 40.07 123.69 2.33 125.66 73.39 264.82 103.7 247.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M363,287.51a181,181,0,0,0-30.93-22.07L315.46,296.3c9.65,5.21,33.77,21.64,42.72,40l25.51-25.72A124.58,124.58,0,0,0,363,287.51Z",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.28,193.89a19.91,19.91,0,0,1-19.92,19.89h-.27A19.9,19.9,0,0,1,98.2,193.86V178.57a19.91,19.91,0,0,1,19.92-19.89h.27a19.91,19.91,0,0,1,19.89,19.92Z",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M133.26,196.28a12.48,12.48,0,0,1-12.5,12.49h-.05a12.48,12.48,0,0,1-12.49-12.5V180.19a12.49,12.49,0,0,1,12.51-12.49h.05a12.5,12.5,0,0,1,12.49,12.5Z",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M372.73,178.76a19.92,19.92,0,0,0-19.89-19.92h-.27a19.91,19.91,0,0,0-19.92,19.89V194a19.89,19.89,0,0,0,19.89,19.91h.27a19.92,19.92,0,0,0,19.92-19.9Z",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M363.71,180.36a12.5,12.5,0,0,0-12.49-12.5h-.05a12.5,12.5,0,0,0-12.51,12.49v16.08a12.5,12.5,0,0,0,12.49,12.5h.05a12.5,12.5,0,0,0,12.51-12.48Z",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M111.8,59.12S110.43,32.73,127.1,24c0,0-7.89,31,32.39,21.78,0,0-44.51,25.42-47.72,15.24",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M114.19,41.14s5.73,11,23.14,5c0,0-10.78,18.27-24.74,1.76A65.63,65.63,0,0,1,114.19,41.14Z",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "73.39 264.82 106.53 329.72 137.76 313.77 103.7 247.06 73.39 264.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M349.73,119A69.41,69.41,0,0,0,280.3,49.59l-93-.07a69.39,69.39,0,0,0-69.48,69.35l-.58,151,232.42,2.18Z",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "320.74 388.93 109.73 388.78 99.37 257.52 331.28 257.69 320.74 388.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M207.76,263.94V273s-20.26,23.13-26,49.51c0,0-31.78-5.37-64.27-48.44l-.25-10.24Z",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M206.73,263.94V273s31.36,23.16,40.56,49.55c0,0,52.6-5.31,102.34-48.32V264Z",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M189.06,263.93s2.82,12.23,9.27,19.62a61.53,61.53,0,0,0,19.64.17S226.55,273,227,264Z",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "321.19 416.98 118.87 416.84 108.81 388.78 321.21 388.93 321.19 416.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "180.03 276.62 173.24 346.74 189.2 359.31 205.7 345.99 199.66 276.63 180.03 276.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M186.86,167.14c0,10.93-5.65,19.78-12.59,19.78s-12.57-8.87-12.56-19.8,5.64-19.78,12.59-19.78S186.86,156.21,186.86,167.14Z",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M176.58,163.42c-1,4.59-3.82,7.87-6.38,7.33s-3.85-4.69-2.89-9.28,3.82-7.86,6.38-7.32S177.54,158.84,176.58,163.42Z",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M261.72,167.19c0,10.93-5.64,19.78-12.59,19.78s-12.57-8.87-12.56-19.8,5.65-19.78,12.59-19.78S261.73,156.26,261.72,167.19Z",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M251.41,163.61c-1.09,4.55-4,7.75-6.59,7.13s-3.71-4.8-2.61-9.35,4-7.75,6.59-7.13S252.51,159.06,251.41,163.61Z",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M165.52,198l94.43.07s-3.16,48.75-51.41,46.48C208.54,244.58,173.12,245.34,165.52,198Z",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M117.75,159.1s4.2-45.36,15.31-52.75l-25-13.95S111.29,126.69,117.75,159.1Z",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M128.3,112.79s131.22,62.35,186.37-11v-12S154.05,119.25,128.3,112.79Z",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M299.24,105.07s18,20.8,41.18,20.84l-11.1-20.82-15.27-7.88Z",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "211.24 505.12 198.63 515.28 119.4 417.01 135.46 404.06 211.24 505.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M227.64,508.89S181.1,513.62,187.81,542c0,0-.31,2.11,4.81,5.71L233.14,515Z",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "252.86 519.88 266.48 526.67 322.84 413.71 305.23 404.93 252.86 519.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M273.8,520.44s44-11.14,48.09,17.71a9.6,9.6,0,0,1-2.38,7l-49.86-14.82Z",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M116,101.4s-.85,18,1.48,27.39c0,0,3.36-18.09,9.7-19.81Z",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M312.67,92.35S294.13,125,256.15,127.26c0,0-221.71,14.66-151.73-98.24,0,0,9.23,29.64,28.68,20.36,0,0,133.41-107.5,192.87,17.32,0,0,46.89-1.85,37.61,38.87l-13.93,53.69-11.1-5.18L333,123.15S313.58,112.49,312.67,92.35Z",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M188.23,125.8s98.6,21.62,124.44-33.45C312.67,92.35,261.65,123.1,188.23,125.8Z",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M312.67,92.35s26.5,4.07,27.76,23.17l9.22,43.74-11.1-5.18L333,125.19S311.73,111.22,312.67,92.35Z",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M133.07,89.68S204.26,140.2,305.82,78C305.82,78,196.27,106.13,133.07,89.68Z",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M133.17,76.87S251.05,90.4,301.83,62.5C301.83,62.5,193,54.87,133.17,76.87Z",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M133.17,66.18S241.1-18.24,301.83,52.94C301.83,52.94,230.72,19.83,133.17,66.18Z",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M322.52,82.83s22.32-.81,27.17,28.39C349.69,111.22,361.1,72,322.52,82.83Z",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 98.88,
    y: 254.6,
    width: 232.44,
    height: 3.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M198.33,283.55a106.74,106.74,0,0,1,9.19-19.28s-9.31,8.26-13.39,13C194.13,277.3,196.67,282.13,198.33,283.55Z",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M207.11,264.7s13.24,8.47,15.68,11.94c0,0-3.7,5.92-4.77,6.92C218,283.56,210.88,270.37,207.11,264.7Z",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M207.83,263.94s-24.53,25.13-29.59,52c0,0-25.21-8.65-60.8-41.8l-.25-10.24Z",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M206,263.94s38.5,25.17,46.56,52c0,0,42.38-8.6,97.08-41.69V264Z",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M358.18,336.32a31,31,0,0,1,3.42,13.27c.09,18.14-21.93,34.14-40.42,44.36l17,30.69c39-21.56,58.66-46.87,58.51-75.23-.07-13.17-4.42-26.15-13-38.81Z",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.77,143.55c-3.21,1.48-8.46-3.08-11.72-10.18L26.83,95c-3.26-7.1-1.09-8.4,2.13-9.88h0c3.22-1.48,8.47,3.09,11.73,10.19l21.52,42.42c3.25,7.1-3.22,4.37-6.44,5.84Z",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.63,155.9c-3.17,1.59-7.54-.73-9.77-5.18L19.58,130.23c-2.23-4.45-1.47-9.34,1.7-10.93h0c3.16-1.59,7.53.73,9.76,5.18L41.32,145c2.23,4.45,1.47,9.34-1.69,10.92Z",
    transform: "translate(-18.3 -6.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.82,150.94c-3.17,1.59-7.54-.73-9.77-5.18L28.77,125.27c-2.23-4.45-1.47-9.34,1.69-10.93h0c3.17-1.59,7.54.73,9.77,5.18L50.51,140c2.23,4.44,1.47,9.34-1.69,10.92Z",
    transform: "translate(-18.3 -6.35)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyGuy);
export default __webpack_public_path__ + "static/media/happy-guy.ff24ecc4759b4c08fe9c29d87cce7735.svg";
export { ForwardRef as ReactComponent };